/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/
import React, {useEffect, useState} from "react";
import SelectHome from "../../Home/SelectHome";
import SelectHVACSystem from "../../System/SelectHVACSystem";
import UseUserAssets from "./UseUserAssets";
import {assetHierarchy, assetHierarchy as asset} from "../../../componentObjects";

const AssetHierarchyView = ({accountId,  fromAssetId, children, onHVACSystemSelect,onNoAssetsReturned , onDeleteHomeSelect}) => {
    let data= UseUserAssets(accountId, fromAssetId , onNoAssetsReturned );
    const [homeList, setHomeList] = useState([]);
    const [systemList, setSystemList] = useState([]);
    
    useEffect(() => {
       
        let isMounted = true;
        function getChild(item, arr){
            arr.push(item);
            if(item.children.length){
                for(let i of item.children) {
                    getChild(i, arr);
                }
            }
        }
        if (isMounted) {
            let accumulator = [];
            let homes = [];
            for (let asset of data) {
                homes.push({orgId:asset.id, nickname:asset.name, children: asset.children});
                getChild(asset, accumulator);
            }
            if (data.length){
                setHomeList(homes);
            }else{
                setHomeList([]);
                setSystemList([]);
                onHVACSystemSelect();
            }

        }
        return () => {
            isMounted = false;
        }
    }, [data]);

    function onChangeHome(e){
        if (e.children.length){
            setSystemList(e.children);
        }else{
            let defaultSystem = [];
            defaultSystem.push(assetHierarchy);
            setSystemList(defaultSystem);
            onHVACSystemSelect();
        }
    }

    function ondeleteHomeSelect(e)
    {
        onDeleteHomeSelect(e)
    }

    

    return (
        <>
            <div className="white-container">
                <div className="select-container-3">
                    <SelectHome className="select-home"  homes={homeList} onChange={onChangeHome} deleteHome={ondeleteHomeSelect}/>
                </div>
            </div>
            <div className="white-container">
                <div className="select-container-3">
                    <SelectHVACSystem className="select-home"  hvacList={systemList} onChange={onHVACSystemSelect}>
                        {children}
                    </SelectHVACSystem>
                </div>
            </div>
        </>
    );
}
export default AssetHierarchyView;